// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { SearchRequestBase } from "./base/search-request-base";

export class RoleSearchRequest extends SearchRequestBase {
}